<div class="flex w-full min-w-0 gap-2 items-center rounded-2xl font-title px-5 py-4 border border-gray-200 hover:ring-gray-300 bg-white">

  <!-- ID -->
  <div class="font-light text-gray-800 text-sm min-w-6">{{ sensor().id }}</div>

  <!-- Nom + lectura -->
  <div class="flex items-center gap-2 justify-between flex-1 min-w-0">
    <div class="font-semibold text-gray-800 truncate">{{ sensor().name }}</div>
    @switch (sensor().state) {
      @case (sensorState().STOPPED) {
        <lib-badge variant="light" color="light" size="sm">{{ sensor().value }} {{ sensor().units }}</lib-badge>
      }
      @case (sensorState().ACTIVE) {
        <lib-badge variant="light" color="primary" size="sm">{{ sensor().value }} {{ sensor().units }}</lib-badge>
      }
      @default {
        <lib-badge variant="light" color="error" size="sm">{{ sensorStateString() }}</lib-badge>
      }
    }
  </div>
</div>
